import {useQuery, useQueryClient} from 'react-query'
import {VisibilityEventEditModalForm} from './VisibilityEventEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'

const VisibilityEventEditModalFormWrapper = () => {
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  // const {
  //   isLoading,
  //   data: visibilityEvent,
  //   error,
  // } = useQuery(
  //   `${QUERIES.PARAMETER_LIST}-parameter-${itemIdForUpdate}`,
  //   () => {
  //     return getParameterById(itemIdForUpdate)
  //   },
  //   {
  //     cacheTime: 0,
  //     enabled: enabledQuery,
  //     onError: (err) => {
  //       setItemIdForUpdate(undefined)
  //       console.error(err)
  //     },
  //   }
  // )


  if (!itemIdForUpdate) {
    return <VisibilityEventEditModalForm  visibilityEvent = {{ id: undefined}} />
  }

  return null
}

export {VisibilityEventEditModalFormWrapper}
